'use strict';

export default function($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/", "/firmwares/list")
  $urlRouterProvider.when("/firmwares", "/firmwares/list");
  $stateProvider
    .state('firmwares', {
      url: '/firmwares?page',
      template: require('./firmwares.html'),
      authenticate: true
    })
    .state('firmwares.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'FirmwaresListController',
      controllerAs: 'firmwaresListCtrl'
    })
    .state('firmwares.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'FirmwaresEditController',
      controllerAs: 'firmwaresEdittCtrl'
    })
    .state('firmwares.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'FirmwaresAddController',
      controllerAs: 'firmwaresAddCtrl'
    })
    .state('firmwares.nanoreaderAdd', {
      url: '/nanoreader/add',
      template: require('./nanoreader/nanoreader.html'),
      controller: 'FirmwaresNanoreaderAddController',
      controllerAs: 'firmwaresNanoreaderAddCtrl'
    })
    .state('firmwares.updated', {
      url: '/updated',
      template: require('./updated/updated.html'),
      controller: 'FirmwaresUpdatedController',
      controllerAs: 'firmwaresUpdatedCtrl'
    })
    .state('firmwares.count', {
      url: '/count',
      template: require('./count/count.html'),
      controller: 'FirmwaresUpdatedCountController',
      controllerAs: 'firmwaresCountCtrl'
    })
    .state('firmwares.lang', {
      url: '/lang',
      template: require('./lang/lang.html'),
      controller: 'FirmwaresLangController',
      controllerAs: 'firmwaresLangCtrl'
    })
    .state('firmwares.model', {
      url: '/model',
      template: require('./model/model.html'),
      controller: 'FirmwaresModelController',
      controllerAs: 'firmwaresModelCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/firmwares/firmwares.routes.js